kombi.template = {
  render: function (text, context) {
    let keys = Object.keys(context);
    let values = Object.values(context);
    return new Function(...keys, `return \`${text}\`;`)(...values);
  },
  render_from_url: function (url, context){
    try {
      let self = this;
      return kombi.requests.getText(url).then((text) => {
        return self.render(text, context);
      })
    } catch (error) {
      console.error("There has been a problem with your render_from_url", error);
    }
  }
}
